import script from "./HackathonRecommendations.vue?vue&type=script&setup=true&lang=js"
export * from "./HackathonRecommendations.vue?vue&type=script&setup=true&lang=js"

import "./HackathonRecommendations.vue?vue&type=style&index=0&id=5ccc32a8&scoped=true&lang=scss"
script.__scopeId = "data-v-5ccc32a8"

export default script